import { Link } from "react-router-dom";
import { Brain, Leaf, ShoppingBag } from "lucide-react";

function Hero() {
  return (
    <section
      className="relative text-white py-20 md:py-32 bg-cover bg-center"
      style={{ backgroundImage: "url('/background3.webp')" }}
    >
      {/* 🔥 Light Colored Overlay */}
      <div className="absolute inset-0 bg-green-900/85"></div>{" "}
      {/* Adjust opacity as needed */}
      {/* Content Container */}
      <div className="relative container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
              The Future of AI-Powered Nutrition & Sustainability
            </h1>
            <p className="text-xl mb-8 text-gray-100">
              A premium AI domain for food tech, organic markets, and AI-driven
              health solutions.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <Link
                to="/contact"
                className="btn-primary bg-accent hover:bg-yellow-600 flex items-center justify-center"
              >
                <ShoppingBag className="mr-2 h-5 w-5" />
                Inquire About Buying
              </Link>
              <Link
                to="/blog"
                className="btn-secondary bg-white/10 border-white text-white hover:bg-white/20 flex items-center justify-center"
              >
                <Brain className="mr-2 h-5 w-5" />
                Explore AI Blog
              </Link>
            </div>
          </div>
          <div className="hidden md:flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-accent rounded-full opacity-5 animate-pulse-slow"></div>
              <div className="relative flex items-center justify-center h-64 w-64">
                <Leaf
                  className="h-24 w-24 text-white absolute"
                  style={{ opacity: 50 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
